import React, { useEffect, useState } from "react";
import { Stack, TextField, popoverClasses } from "@mui/material";
import _ from "lodash";
import "../../index.css";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  conflictDataActions,
  feedbackActions,
  shelfViewFeedbackActions,
  thumbnailStoreActions,
} from "../../store/store";
import "../annotator.css";
import GenerateConflictedThumbnails from "./GenerateConflictedThumbnails";
import {
  markAsDiscarded,
  updateThumbnailDetailsAndKey,
} from "../../store/ShelfView/conflictThumbnail";
import { StyledAutocompleteBlue } from "../components/styled_autocomplete";
import { makeStyles } from "@mui/styles";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {
  resetState,
  setClickedThumbnail,
  setOpenClicked,
} from "../../store/ShelfView/conflictsPage";
import PopUp from "./PopUp";

const ConflictsThumbnailViewer = () => {
  const dispatch = useDispatch();
  const { loading, selectedZoom } = useSelector(
    (state) => state.shelfViewFeedbackStore
  );

  const { user, username, userId } = useSelector((state) => state.userStore);

  const { cursorDetails2 } = useSelector(
    (state) => state.conflictThumbnailStore
  );
  const currentKey=cursorDetails2.currentKey;
  const { cursorDetails } = useSelector((state) => state.thumbnailStore);

  const {
    conflicts,
    curConflict,
    conflictedBrands,
    selectedConflictBrand,
    selectedThumbnailsToMarkCorrect,
  } = useSelector((state) => state.conflictDataStore);

  let thumbnails = cursorDetails2.thumbnailDetails;
  useEffect(()=>{
    thumbnails = selectedConflictBrand !== null
    ? cursorDetails2.thumbnailDetails.filter((th) => th.predictions.sku_name === selectedConflictBrand)
    : thumbnails;
    console.log(thumbnails,"filtered thumbnails")
  },[thumbnails,selectedConflictBrand])
 
  console.log(thumbnails);

  const endOfThumbnailList = cursorDetails2.endOfThumbnailList;
  const { open } = useSelector((state) => state.conflictsPageStore);

  const [infiniteLoadingLowerbound, setInfiniteLoadingLowerbound] = useState(0);
  const [infiniteLoadingUpperbound, setInfiniteLoadingUpperbound] =
    useState(200);
  const [thumbnailsToDisplay, setThumbnailsToDisplay] = useState([]);
  const [infiniteLoadingMessage, setInfiniteLoadingMessage] = useState("");
  const [selectedThumbnail, setSelectedThumbnail] = useState([]);
  const [toRun, setToRun] = useState(true);
  const [clicked, setClicked] = useState(false);

  const [anchor, setAnchor] = React.useState(null);
  //console.log(curConflict)
//console.log(window.innerHeight)
  useEffect(() => {
    dispatch(shelfViewFeedbackActions.setLoading(true));
    const func = async () => {
      try {
        //console.log("called useEffect!")
        const response = await axios.post("/markThumbnail/renderThumbnails", {
          type_of_issue: curConflict,
          ...cursorDetails,
        });
        dispatch(conflictDataActions.setConflictedBrands(response.data));
        dispatch(conflictDataActions.setSelectedConflictedBrand(null));
        //console.log(response)
        if (response.data.thumbnailDetails.length < 1) {
          setToRun(false);
        }
        dispatch(updateThumbnailDetailsAndKey(response.data));
      } catch (error) {
        console.log(error, "error");
      }
    };
    if (thumbnailsToDisplay.length < 1 && toRun) {
      //console.log("true")
      func();
      // console.log("called")
    }
    // console.log(thumbnails.length)
    dispatch(shelfViewFeedbackActions.setLoading(false));
  }, [thumbnailsToDisplay]);

  //console.log(toRun)
  useEffect(() => {
    const thumbnailData = [...cursorDetails.thumbnailDetails];
    const updatedThumbnailDetails = thumbnailData.map((r) => {
      const { discarded, ...rest } = r;
      return rest;
    });
    dispatch(thumbnailStoreActions.markAsDiscarded(updatedThumbnailDetails));
  }, [thumbnails]);

  // console.log(selectedThumbnailsToMarkCorrect);

  useEffect(() => {
    const container = document.querySelector(".thumbnail-grid");

    if (thumbnails.length === 0) {
      console.log("scrolling to top");
      container.scrollTop = 0;
    }

    const handleScroll = () => {
      if (container) {
        const { scrollHeight, scrollTop, offsetHeight } = container;
        const scrollPercentage =
          (scrollTop / (scrollHeight - offsetHeight)) * 100;
        const thresholdPercentage = 95;

        if (scrollPercentage >= thresholdPercentage) {
          // fetaching more data
          let updatedUpperBound = infiniteLoadingUpperbound + 10;

          if (updatedUpperBound >= thumbnails.length) {
            updatedUpperBound = thumbnails.length;
          }

          setInfiniteLoadingLowerbound(infiniteLoadingLowerbound);
          setInfiniteLoadingUpperbound(updatedUpperBound);
          setThumbnailsToDisplay(
            thumbnails.slice(infiniteLoadingLowerbound, updatedUpperBound)
          );
        }
      }
    };

    if (
      !endOfThumbnailList &&
      thumbnails.length > 0 &&
      thumbnailsToDisplay.length === thumbnails.length
    ) {
      setInfiniteLoadingMessage(
        "To load more thumbnails, mark these as correct"
      );
    } else if (endOfThumbnailList) {
      setInfiniteLoadingMessage(
        "You have reached the end of the list of thumbnails, select another node to continue"
      );
    } else {
      setInfiniteLoadingMessage("");
    }

    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [
    thumbnailsToDisplay,
    infiniteLoadingLowerbound,
    infiniteLoadingUpperbound,
  ]);

  useEffect(() => {
    setThumbnailsToDisplay(
      thumbnails.slice(infiniteLoadingLowerbound, infiniteLoadingUpperbound)
    );

    if (thumbnails.length === 0) {
      setThumbnailsToDisplay([]);
      setInfiniteLoadingUpperbound(200);
    }
  }, [thumbnails,selectedConflictBrand]);

  const markAsCorrectFunc = async (item) => {
    const thumbnailData = [...cursorDetails2.thumbnailDetails];
    const updatedThumbnailDetails = thumbnailData.map((r) => {
      let obj = { ...r };
      if (
        obj.thumbnailName === item.thumbnailName &&
        obj.xmin === item.xmin &&
        obj.xmax === item.xmax &&
        obj.ymin === item.ymin &&
        obj.ymax === item.ymax
      ) {
        obj.discarded = !obj.discarded;
        return obj;
      } else {
        return obj;
      }
    });
    dispatch(conflictDataActions.appendToSelectedThumbnails(item));

    dispatch(markAsDiscarded(updatedThumbnailDetails));
  };
  console.log(thumbnailsToDisplay);
  //console.log(selectedThumbnail);

  const handleChange = (value, name) => {
    const filteredThumbnail = thumbnails.filter(
      (th) => th.predictions.sku_name === value
    );
    // setThumbnailsToDisplay(filteredThumbnail);
    dispatch(conflictDataActions.setSelectedConflictedBrand(value));
    console.log("handle")
  };


  const useAutoCompleteStyles = makeStyles({
    option: {
      fontSize: "0.875rem",
    },
  });

  const zoomThumbnails = async (customHeight, type) => {
    if(type==="zoom-in")
  {
    dispatch(shelfViewFeedbackActions.increaseHeight())
  }
  else{
    dispatch(shelfViewFeedbackActions.decreaseHeight())
  }
   // dispatch(shelfViewFeedbackActions.setZoomDynamicHeight(customHeight));
    dispatch(shelfViewFeedbackActions.setZoom(type));
  };
  const handleClick = (event) => {
    dispatch(resetState());
    setClicked((prevValue) => !prevValue);
    // dispatch(setClickedThumbnail(props))

    setAnchor(anchor ? null : event.currentTarget);
    dispatch(setOpenClicked(Boolean(anchor ? null : event.currentTarget)));
  };
 
  const deleteThumbnailsFunc=async(type)=>{
    dispatch(shelfViewFeedbackActions.setLoading(true));
  
    if(selectedThumbnailsToMarkCorrect.length<1)
    {
      dispatch(feedbackActions.setSnackbarOpen(true))
      dispatch(
        feedbackActions.setSnackbarMessage(
          'No Selected thumbnails present, Resolve it !'
        )
      )
      dispatch(feedbackActions.setSnackbarMessageSeverity('warning'))
      setTimeout(() => {
        dispatch(feedbackActions.setSnackbarOpen(false));
      }, 5000);
    }
    else{
      const filteredThumbnail = thumbnails.filter((th) => {
        return !selectedThumbnailsToMarkCorrect.some((selected) => selected.thumbnailName === th.thumbnailName);
      });
     
      let filteredBrands=filteredThumbnail.map((th)=>th.predictions.sku_name);
      filteredBrands=[...new Set(filteredBrands)]
      const thumbnailsName=selectedThumbnailsToMarkCorrect.map((t)=>t.thumbnailName);
    
      let selectedkeys =[currentKey];
     
      try {
        const response = await axios.post(
          '/remove_thumbnails/discard_thumbnails',
          {
            ...cursorDetails,
            selectedThumbnails: selectedThumbnailsToMarkCorrect,
            thumbnailsName: thumbnailsName,
            selectedkeys: selectedkeys
          }
        )
        //console.log(response)
      } catch (err) {
        console.log(err, 'error')
      }
      const cursorDetails2={
        thumbnailDetails:filteredThumbnail,
        currentKey:currentKey
      }
      //console.log(cursorDetails2)
      dispatch(resetState())
      dispatch(updateThumbnailDetailsAndKey(cursorDetails2));
      const brands={
        brands:filteredBrands
      }
      dispatch(conflictDataActions.setSelectedConflictedBrand(null))
      dispatch(conflictDataActions.setConflictedBrands(brands))
      dispatch(conflictDataActions.resetSelectedThumbnailsToMarkCorrect())
      
    }
    dispatch(shelfViewFeedbackActions.setLoading(false));
   }
 
  const autocomplete_classes = useAutoCompleteStyles();
  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <StyledAutocompleteBlue
          sx={{ width: "25%", marginBottom: "1rem" }}
          classes={{
            option: autocomplete_classes.option,
          }}
          id="size-small-outlined-multi"
          size="small"
          noOptionsText="Loading..."
          value={selectedConflictBrand}
          componentsProps={{ popper: { style: { minWidth: "20.4%" } } }}
          options={conflictedBrands}
          getOptionLabel={(option) => option}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={`Select a brand`}
              label="Brand"
            />
          )}
          onChange={(event, value) => handleChange(value, "brand")}
        />

        <ButtonGroup
          variant="text"
          aria-label="text button group"
          style={{
            backgroundColor: "aliceblue",
            marginLeft: "auto",
            marginRight: "1rem",
          }}
        >
          {selectedZoom === "zoom-in" ? (
            <Button
              className=" selectedZoom"
              onClick={() => zoomThumbnails(250, "zoom-in")}
            >
              <ZoomInIcon />
            </Button>
          ) : (
            <Button
              className="conflict-options"
              onClick={() => zoomThumbnails(250, "zoom-in")}
            >
              <ZoomInIcon />
            </Button>
          )}
          {selectedZoom === "zoom-out" ? (
            <Button
              className="selectedZoom"
              onClick={() => zoomThumbnails(10, "zoom-out")}
            >
              <ZoomOutIcon />
            </Button>
          ) : (
            <Button
              className="conflict-options"
              onClick={() => zoomThumbnails(10, "zoom-out")}
            >
              <ZoomOutIcon />
            </Button>
          )}
            <Button
          className='conflict-options'
          onClick={() => deleteThumbnailsFunc("conflicted")}
        >
          <DeleteForeverIcon />
        </Button>
          <Button className="conflict-options" onClick={handleClick}>
            {open ? <CheckCircleOutlineIcon /> : <BeenhereIcon />}
          </Button>
        </ButtonGroup>
      </div>
      <div className="thumbnail-grid">
        {thumbnailsToDisplay.length > 0 &&
          thumbnailsToDisplay.map((r, index) => (
            <div key={index} onClick={() => markAsCorrectFunc(r)}>
              {/* <div key={index}> */}
              <GenerateConflictedThumbnails data={r} />
            </div>
          ))}

        {clicked && (
          <PopUp
            anchor={anchor}
            setAnchor={setAnchor}
            clicked={clicked}
            setClicked={setClicked}
          />
        )}
        <div className="infinite-loading-message">{infiniteLoadingMessage}</div>
      </div>
    </div>
  );
};

export default ConflictsThumbnailViewer;
